<template>
    <div>
        <div class="input-group responsive-element">
            <input type="text" v-model="filterText" @keydown="handleButton" :placeholder="[[ __('misc.search') ]]" class="form-control" aria-label="Text input with dropdown button">
            <div class="input-group-append">
                <button not-disabled-permission="true" class="btn btn--only-icon btn--blue filter-people-button" type="button" @click="doFilter"><i class="fal fa-search"></i></button>
            </div>
            <div class="input-group-append" v-if="isVisibile" data-toggle="tooltip" data-placement="top" :title="__('misc.filterByCriterion')">
                <button class="btn btn--white dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ selectedItem.label }}</button>
                <div class="dropdown-menu">
                    <span v-for="item in filter_fields_data" v-bind:key="item.value">
                        <a class="dropdown-item" @click="setSelectedItem(item.value)" href="#">{{item.label}}</a>    
                    </span>                
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {            
            if (this.filter_fields_data == null){
                this.isVisibile = false;
                this.filter_fields_data = [{ value: "all", label: this.__("misc.all"), isSelected: false }];
            } else {
                for(let i = 0; i < this.filter_fields_data.length; i++){
                    if (this.filter_fields_data[i].value == 'all'){
                        this.filter_fields_data[i].label = this.__("misc.all");
                    }
                }
            }
            this.setSelectedItem('all');
        },
        data () {
            return {
              isVisibile: true,
              eventPrefix: 'vuetable-filterBar:',
              filterText: '',
              select1:'all',
              filter_fields_data:this.filter_fields,
              selectedItem: this.__("misc.all")

            }
        },
        methods: {
            handleButton(e) {
              if (e.keyCode === 13) {
                e.preventDefault();
                this.doFilter();
                return false;
              }
            },
            doFilter (e) {
                this.$emit(this.eventPrefix+'doFilter', this.filterText);
            },
            resetFilter () {
                this.filterText = "";
                this.$emit(this.eventPrefix+'resetFilter', this.filterText);
            },
            setSelectedItem(selectedValue) {                                                      
                for(let i = 0; i < this.filter_fields_data.length; i++){
                    if (selectedValue != this.filter_fields_data[i].value){
                        this.filter_fields_data[i].isSelected = false;
                    } else {
                        this.filter_fields_data[i].isSelected = true;
                        this.selectedItem = this.filter_fields_data[i];
                        this.select1 = this.selectedItem.value;
                        this.$refs.filterSelected = this.selectedItem;
                    }                    
                }                
            }
        },
        props: {
          filter_fields: Array,
        }
    }
</script>



<style lang="scss" scoped>
  
.input-group
::placeholder {color:#1767A2}

input {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border:none;
    font-size:13px;
    color:#1767A2;
    height: 38px;
}

button.filter-people-button {
    width:20px !important;
    box-shadow: none !important;
}
</style>